<template>
  <div class="table-filters__wrapper">
    <mc-select
      hiddenlabel
      class="table-filters__select"
      optionswidth="275px"
      name="timeFrames"
      :value="timeFrame"
      labelposition="left"
      @optionselected="$emit('updateComponentTimeFrame', $event)"
    >
      <mc-option v-for="opt in timeframeOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</mc-option>
    </mc-select>
    <mc-input
      class="table-filters__input"
      hiddenlabel
      :loading="loading && refSearch?.length > 0"
      :placeholder="$t('filter.searchRef')"
      icon="magnifying-glass"
      clearbutton
      data-test="reference-search"
      @input="referenceSearch($event)"
      @clearbuttonclick="resetSearch()"
    />
  </div>
</template>

<script>
import { mapState, mapWritableState } from "pinia";
import { shipments } from "@/store/shipments";

export default {
  name: "TableFilters",
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ["updateComponentTimeFrame", "referenceSearch", "resetReferenceSearch"],
  data() {
    return {
      timeframeOptions: [
        {
          label: this.$route?.path?.includes("export")
            ? this.$t("filter.departingTimes.next3days")
            : this.$t("filter.arrivingTimes.next3days"),
          value: "next_3_days"
        },
        {
          label: this.$route?.path?.includes("export")
            ? this.$t("filter.departingTimes.next7days")
            : this.$t("filter.arrivingTimes.next7days"),
          value: "next_7_days"
        },
        {
          label: this.$route?.path?.includes("export")
            ? this.$t("filter.departingTimes.nextMonth")
            : this.$t("filter.arrivingTimes.nextMonth"),
          value: "next_month"
        },
        {
          label: this.$route?.path?.includes("export")
            ? this.$t("filter.departingTimes.next3months")
            : this.$t("filter.arrivingTimes.next3months"),
          value: "next_3_months"
        },
        {
          label: this.$route?.path?.includes("export")
            ? this.$t("filter.departingTimes.last3days")
            : this.$t("filter.arrivingTimes.last3days"),
          value: "last_3_days"
        },
        {
          label: this.$route?.path?.includes("export")
            ? this.$t("filter.departingTimes.last7days")
            : this.$t("filter.arrivingTimes.last7days"),
          value: "last_7_days"
        },
        {
          label: this.$route?.path?.includes("export")
            ? this.$t("filter.departingTimes.lastMonth")
            : this.$t("filter.arrivingTimes.lastMonth"),
          value: "last_month"
        },
        {
          label: this.$route?.path?.includes("export")
            ? this.$t("filter.departingTimes.last3months")
            : this.$t("filter.arrivingTimes.last3months"),
          value: "last_3_months"
        }
      ]
    };
  },
  computed: {
    ...mapState(shipments, ["timeFrame"]),
    ...mapWritableState(shipments, ["refSearch"])
  },
  unmounted() {
    this.resetSearch();
  },
  methods: {
    referenceSearch($event) {
      this.refSearch = $event.target.value;

      if ($event.target?.value?.length > 2) {
        this.$emit("referenceSearch");
      } else if (this.resetState($event)) {
        this.resetSearch();
      }
    },
    resetSearch() {
      this.refSearch = "";
      this.$emit("resetReferenceSearch");
    },
    resetState(event) {
      return Boolean(this.refSearch && event.target?.value?.length <= 2);
    }
  }
};
</script>
